var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClockIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M28.6328 8.41992C27.9701 8.74056 27.6927 9.53809 28.0133 10.2005C28.8893 12.0101 29.3333 13.9606 29.3333 16C29.3333 23.3519 23.3519 29.3333 16 29.3333C8.64811 29.3333 2.66667 23.3519 2.66667 16C2.66667 8.64811 8.64811 2.66667 16 2.66667C19.0465 2.66667 21.9085 3.66146 24.2773 5.54329C24.8519 6.00195 25.6921 5.90592 26.1507 5.32943C26.6094 4.75326 26.5133 3.91406 25.9365 3.45605C23.1322 1.22721 19.6032 0 16 0C7.17806 0 0 7.17806 0 16C0 24.8219 7.17806 32 16 32C24.8219 32 32 24.8219 32 16C32 13.5553 31.4661 11.2126 30.4134 9.03939C30.0934 8.37533 29.2933 8.09863 28.6328 8.41992Z",
    fill: "#3030AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M15.9998 5.3335C15.2638 5.3335 14.6665 5.93083 14.6665 6.66683V16.0002C14.6665 16.7362 15.2638 17.3335 15.9998 17.3335H22.6665C23.4025 17.3335 23.9998 16.7362 23.9998 16.0002C23.9998 15.2642 23.4025 14.6668 22.6665 14.6668H17.3332V6.66683C17.3332 5.93083 16.7358 5.3335 15.9998 5.3335Z",
    fill: "#3030AD"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClockIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clockIcon.864bbb919632f21391f3f5027322c657.svg";